import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import './Navbar.css';

const ADMIN_EMAILS = ['junlim3@illinois.edu', 'alexison@usc.edu', 'alexison.pan@gmail.com'];

const Navbar = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsAdmin(ADMIN_EMAILS.includes(user.email));
      } else {
        setIsAdmin(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-brand">
        <Link to="/">Visualize AI</Link>
      </div>
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/privacy">Privacy Policy</Link>
        {/* <Link to="/video-settings">Video Settings</Link> */}
        {/* <Link to="/syllabus-upload">Syllabus Upload</Link> */}
        {isAdmin && <Link to="/admin">Admin</Link>}
        <button onClick={handleSignOut} className="sign-out-btn" title="Sign Out">
          <svg 
            className="account-icon" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h7v2H5v14h7v2Zm11-4l-1.375-1.45l2.55-2.55H9v-2h8.175l-2.55-2.55L16 7l5 5Z"/>
          </svg>
        </button>
      </div>
    </nav>
  );
};

export default Navbar; 